import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  setFirebaseToken,
  notificationUpdate,
  NotificationState,
  notificationClearCounter,
  getNotifications,
  getUnreadNotifications,
} from './index';
import { NotificationProps } from './types';

export const initialState: NotificationState = {
  notifications: [] as any,
  notificationCount: 0,
  firebaseToken: '',
  status: '',
  isFetching: false,
  isError: false,
  message: '',
  allNotifications: [] as NotificationProps[],
  totalElements: 0,
  total: 0,
  unreadNotifications: [],
};

interface SetFirebaseTokenPayload {
  status: string;
  data: string; 
}

interface NotificationUpdatePayload {
  status: string;
  data: NotificationProps; 
}

interface GetNotificationsPayload {
  status: string;
  data: NotificationProps[] | undefined;
  total:number;
  message: string;
}

export const NotificationSlice = createSlice({
  name: 'notification',
  initialState: initialState, 
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setFirebaseToken.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(
        setFirebaseToken.fulfilled,
        (state, action: PayloadAction<SetFirebaseTokenPayload>) => {
          state.status = action.payload.status;
          state.firebaseToken = action.payload.data; 
        },
      )
      .addCase(setFirebaseToken.rejected, (state) => {
        state.status = 'error';
      })
      .addCase(
        notificationUpdate.fulfilled,
        (state, action: PayloadAction<NotificationUpdatePayload>) => {
          state.status = action.payload.status; 
          state.notifications.unshift(action.payload.data); 
          state.notificationCount += 1;
        },
      )
      .addCase(notificationClearCounter.fulfilled, (state) => {
        state.status = 'success';
        state.notificationCount = 0;
      })
      .addCase(getNotifications.pending, (state) => {
        state.isFetching = true;
        state.isError = false;
      })
      .addCase(getNotifications.fulfilled,(state, action) => {
          const { status, message, total, data } = action.payload;
          state.isFetching = false;
          if (status === 'success') {
            state.allNotifications = data || []; 
            state.total= total || 0;
            state.message = '';
          } else {
            state.isError = true;
            state.message = message || 'Failed to fetch notifications';
          }
        },
      )
      .addCase(getNotifications.rejected, (state, action) => {
        state.isFetching = false;
        state.isError = true;
        state.message = action.error.message || 'An error occurred';
      })
      .addCase(getUnreadNotifications.fulfilled, (state, action) => {
        state.isFetching = false;
        if(action.payload.status === 'success') {
          state.unreadNotifications = action.payload.unreadNotifications || [];
        } else {
          state.unreadNotifications = [];
        }
      })
      .addCase(getUnreadNotifications.rejected, (state) => {
        state.isFetching = false;
        state.isError = true;
      });
  },
});

export const NotificationReducer = NotificationSlice.reducer;
